<template>
  <div class="comment-display">
    <div class="panel-container col-12 comment-container">
      <label class="label d-flex justify-content-between text-muted">
        Recomendación:
        <span
          v-if="!isReadOnly && showRemoveButton"
          class="far fa-times-circle color-red"
          role="button"
          @click="removeComment"
        ></span>
      </label>
      <div class="comment-box p-0">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="value.comment"
            :placeholder="'Comentario'"
            :maxlength="2000"
            :count-classes="['d-block text-right']"
            :disabled="isReadOnly"
            :error="errors[0] ? 'err' : ''"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from '@quisit/custom-text-area';

export default {
  components: {
    CustomTextArea,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => ({
        comment: null,
      }),
    },
    showRemoveButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    removeComment() {
      this.$emit('remove-comment', this.value);
    },
  },
};
</script>

<style lang="scss">
.comment-container {
  margin-bottom: 20px; /* Adjust the desired margin between comment boxes */
}

/* Add your styling for CommentDisplay if needed */
.panel-container {
  background-color: #f0f0f0;
  padding: 20px;
  border-radius: 10px;
}

.comment-box-panel {
  background-color: #ffffff;
  padding: 15px;
  margin-top: 10px;
  border-radius: 8px;
}
</style>
